<template>


  <div class="content_journal" v-if="proofLoginStatus">

  	<h1 class="entry-title ueberschrift">Archivsuche</h1>

  	<div class="woocommerce-error" role="alert" v-if="summaryerror">Fehler. {{ summaryerrordescription }}</div>

  	<div class="filterBlock" v-on:keyup.enter="searchDocuments()" tabindex="0" style="outline:none;">
  		<div class="cols">
	  		<div class="col1">
	  			<div class="inputsection">
			  		<label>Dokumententyp</label><br/>
			  		<multiselect v-model="dokumententyp" :options="dokumententyp_options" :multiple="true" placeholder="Bitte auswählen" class="multiselectInput" deselectLabel="Entfernen" selectLabel="Auswählen" selectedLabel="Ausgewählt" tabindex="1"></multiselect>
			  	</div>
			  	<div class="inputsection">
			  		<label>Datenherkunft</label><br/>
			  		<input type="text" v-model="datenherkunft" tabindex="2">
			  	</div>
	  		</div>
	  		<div class="col2">
	  			<div class="inputsection">
	  				<label>Rechnungssteller</label><br/>
			  		<input type="text" v-model="rechnungssteller" tabindex="3">
			  	</div>
			  	<div class="inputsection">
			  		<label>Belegnummer</label><br/>
			  		<input type="text" v-model="belegnummer" tabindex="4">
			  	</div>
	  		</div>
	  		<div class="col3">
	  			<div class="inputsection">
	  				<label>Belegdatum</label><br/>
			  		<date-picker v-model="belegdatum" range format="DD.MM.YYYY" range-separator=" - " tabindex="5"></date-picker>
			  	</div>
			  	<div class="inputsection">
	  				<label>Eingangsdatum</label><br/>
			  		<date-picker v-model="eingangsdatum" range format="DD.MM.YYYY" range-separator=" - " tabindex="6"></date-picker>
			  	</div>
	  		</div>
  		</div>
	    <div class="buttonsBlock">
		  	<button class="closeButtonAndBack smaller black" style="width:auto;margin-left:0px;padding-left:20px;padding-right:20px;float:left;" @click="searchDocuments()" v-on:keyup.enter="searchDocuments()" tabindex="7">Suchen</button>
		  	<!-- <button class="closeButtonAndBack smaller white"style="width:auto;padding-left:20px;padding-right:20px;float:left;margin-left:5px;" @click="listDocuments('*',null,getMaxRowsPerPageCommit,false,false,true)">Abbrechen</button> -->
	  	</div>
  	</div>

  	<div v-if="submitSearch">
	  	<table v-if="documents.length > 0" class="documentslist" style="border-bottom:0px;">
			<tr class="head">
				<th style="cursor:pointer;" @click="sortBuilder('belegtyp', 'asc')">
					Dokumententyp
					<i v-if="getSortSetting.sort == 'belegtyp'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
					<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
				</th>
				<th style="cursor:pointer;" @click="sortBuilder('kreditorname', 'asc')">
					Rechnungssteller
					<i v-if="getSortSetting.sort == 'kreditorname'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
					<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
				</th>
				<th style="cursor:pointer;" @click="sortBuilder('belegnummer', 'asc')">
					Belegnummer
					<i v-if="getSortSetting.sort == 'belegnummer'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
					<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
				</th>
				<th style="text-align:right;cursor:pointer;" @click="sortBuilder('belegdatum', 'asc')">
					Belegdatum
					<i v-if="getSortSetting.sort == 'belegdatum'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
					<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
				</th>
				<th style="text-align:right;cursor:pointer;" @click="sortBuilder('eingangsdatum', 'asc')">
					Eingangsdatum
					<i v-if="getSortSetting.sort == 'eingangsdatum'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
					<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
				</th>
				<th style="text-align:right;cursor:pointer;" @click="sortBuilder('belegstatus', 'asc')">
					Belegstatus
					<i v-if="getSortSetting.sort == 'belegstatus'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
					<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
				</th>
			</tr>
	  		<tr v-for="(item, $index) of documents" @click="showDocument(item['id'])">
	  			<td>
	  				<span v-if="item['belegtyp'] == 'Rechnungsanhang'">
	  					XML-Rechnung
	  				</span>
	  				<span v-else>
	  					{{item['belegtyp']}}
	  				</span>
	  			</td>
	  			<td>{{item['kreditorname']}}</td>
	  			<td>{{item['belegnummer']}}</td>
	  			<td style="text-align:right;">{{item['belegdatum'] | formatDate}}</td>
	  			<td style="text-align:right;">{{item['filedate'] | formatDateTime}}</td>
<!-- 	  			<td style="text-align:right;">
	  				<span v-if="item['statuslist']">
	  					<span v-if="item['statuslist'][0] == 'Rechnung_valid-e-invoice_true'" style="color:green;"><i class="fa-solid fa-circle-check" style="font-size:20px;"></i></span>
	  					<span v-else style="color:red;"><i class="fa-solid fa-circle-xmark" style="font-size:20px;"></i></span>
	  				</span>
	  			</td> -->
	  			<td style="text-align:right;">
	  				<span v-if="item['statuslist']">
	  					<span v-if="item['statuslist'][0] == 'Rechnung_valid-e-invoice_true'" style="color:#7cb430;font-weight:bold;">
	  						<i class="fa-solid fa-circle-check" style="font-size:20px;"></i><br/>valid
	  					</span>
	  					<span v-else-if="item['statuslist'][0] == 'Rechnung_validation-failed_true'" style="color:#0a0a0a;font-weight:bold;">
	  						<i class="fa-solid fa-circle-info" style="font-size:20px;"></i><br/>fehlgeschlagen
	  					</span>
	  					<span v-else-if="item['statuslist'][0] == 'Rechnung_invalid-e-invoice_true'" style="color:#af301c;font-weight:bold;">
	  						<i class="fa-solid fa-circle-xmark" style="font-size:20px;"></i><br/>invalid
	  					</span>
	  					<span v-else-if="item['statuslist'][0] == 'Rechnung_no-e-invoice_true'" style="color:#0a0a0a;font-weight:bold;">
	  						<i class="fa-solid fa-circle-exclamation" style="font-size:20px;"></i><br/>keine<br/>E-Rechnung
	  					</span>
	  					<span v-else style="color:#0a0a0a;">
	  						<!-- <i class="fa-solid fa-file-invoice" style="font-size:20px;"></i> -->
	  					</span>
	  				</span>
	  			</td>
	  		</tr>
			<tr class="footer" style="background-color:#5f5e5e;">
  				<td colspan="8" style="color:#fff;text-align:right;padding: 15px 20px;font-weight:700;">Anzahl der Treffer: {{getTrefferAnzahl}}</td>
  			</tr>
	  	</table>
	  	<table v-else class="documentslist">
	  		<tr class="head">
				<th>Dokumententyp</th>
				<th>Rechnungssteller</th>
				<th>Belegnummer</th>
				<th>Belegdatum</th>
				<th>Eingangsdatum</th>
				<th>Belegstatus</th>
			</tr>
			<tr>
				<td colspan="6" style="font-weight:bold;text-align:center;">Keine Dokumente gefunden.</td>
			</tr>
	  	</table>

	  	<!-- <div style="text-align:right;font-size:15px;font-weight:bold;">
	  		<span v-if="getTrefferAnzahl">Anzahl der Treffer: {{getTrefferAnzahl}}</span>
	  		<span v-else>Anzahl der Treffer: 0</span>
	  	</div> -->

  	</div>
 
  </div>

</template>

<script>

//import axios from 'axios';
//import DocumentSingleView from './DocumentSingleView'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'

export default {
	components: { Multiselect, DatePicker },
	data() {
		return {
			apiResponse: '', // initial loading or error messages.
			wpPosts: [], // REST API response data goes here.
			wpData, // global data made available via wp_localize_script.
			summaryerror: false,
			summaryerrordescription: '',
			forwardTest: true,
			belegnummer: '',
			dokumententyp_options: ['Rechnung', 'Email', 'XML-Rechnung', 'Sichtkopie', 'Validierungsbericht XML', 'Validierungsbericht PDF'],
			dokumententyp: '',
			rechnungssteller: '',
			belegdatum: '',
			eingangsdatum: '',
			submitSearch: false,
			datenherkunft: ''
		};
	},

	beforeMount() {
		//this.$store.commit('setMaxRowsPerPage', localStorage.getItem('maxRowsPerPage'))
		// if (this.getAllMarkers) {
		// 	this.listDocuments(this.getAllMarkers[this.getPage], null, this.getMaxRowsPerPageCommit, false);
		// } else {
		// 	this.listDocuments("*", null, this.getMaxRowsPerPageCommit, false)
		// }
	},

	computed: {
      	proofLoginStatus() {
      		if (this.$store.getters.isPortinvoiceLoggedIn != "") {
      			return true	
      		} else {
      			this.$router.push('/noAccess');
      		}
      	},
		documents() {
			var documents = this.$store.getters.getDocuments
			return documents
		},
		getTrefferAnzahl() {
			return this.$store.getters.getTrefferAnzahl
		},
		getSortSetting() {
			return this.$store.getters.getSortSetting
		}
	},

	mounted() {
		this.$store.commit('setSortSetting', {})
		if (this.$route.params.backToSearchOverview) {
            var backToSearchOverview = this.$route.params.backToSearchOverview
            if (this.$store.getters.getSearchQuery) {
            	var searchQuery = this.$store.getters.getSearchQuery
            	this.searchDocuments(searchQuery)
	            if (this.$store.getters.getSearchParameter) {
		            var searchParameter = this.$store.getters.getSearchParameter
		            this.datenherkunft = searchParameter.datenherkunft
		            this.dokumententyp = searchParameter.dokumententyp
		            this.belegnummer = searchParameter.belegnummer
		            this.belegdatum = searchParameter.belegdatum
		            this.rechnungssteller = searchParameter.rechnungssteller
		            this.eingangsdatum = searchParameter.eingangsdatum            	
	            } else {
	            	//console.log("getSearchParameter konnten nicht geladen werden")
	            	this.$store.commit('setStopLoadingWorkingScreen')
	            }
        	} else {
        		console.log("getSearchQuery konnte nicht geladen werden")
        		this.$store.commit('setStopLoadingWorkingScreen')
        	}
        } else {
        	this.$store.commit('setStopLoadingWorkingScreen')
        }
	},

	methods: {

		showDocument(noderef) {
			this.$store.commit('setLoadingWorkingScreen')
			var ticket = this.$store.getters.getAccessTicket
			this.$router.push({
				name: 'DocumentSingleView',
				params: {
					noderef: noderef,
					ticket: ticket,
					referer: "suche"
				}
			})
		},

		sortBuilder(sort, sortDirection) {
			var documents = this.$store.getters.getDocuments

			var currentSortSettings = this.$store.getters.getSortSetting
			if (Object.keys(currentSortSettings).length !== 0) {
				if (currentSortSettings.sort == sort) {
					if (currentSortSettings.sortDirection == "desc") {
						sortDirection = "asc"
					} else {
						sortDirection = "desc"
					}
				}
			}
			var sortSetting = {
				'sort': sort,
				'sortDirection': sortDirection
			}
			this.$store.commit('setSortSetting', sortSetting)

			if (sort == "kreditorname") {
				documents.sort(function(a, b){
					if (!("kreditorname" in a)) {
						a['kreditorname'] = ""
					}
					if (!("kreditorname" in b)) {
						b['kreditorname'] = ""
					}
					let x = a['kreditorname'].toLowerCase();
					let y = b['kreditorname'].toLowerCase();
				    if(x === "" || x === null) return 1;
					if(y === "" || y === null) return -1;
					if(x === y) return 0;
					if (sortSetting.sortDirection == "asc") {
						return x < y ? -1 : 1;
					} else {
						return x > y ? -1 : 1;
					}
				});
			} else if (sort == "belegnummer") {
				documents.sort(function(a, b){
					if (!("belegnummer" in a)) {
						a['belegnummer'] = ""
					}
					if (!("belegnummer" in b)) {
						b['belegnummer'] = ""
					}
					let x = a['belegnummer'].toLowerCase();
					let y = b['belegnummer'].toLowerCase();
				    if(x === "" || x === null) return 1;
					if(y === "" || y === null) return -1;
					if(x === y) return 0;
					if (sortSetting.sortDirection == "asc") {
						return x < y ? -1 : 1;
					} else {
						return x > y ? -1 : 1;
					}
				});
			} else if (sort == "belegdatum") {
				documents.sort(function(a, b){
					if (!("belegdatum" in a)) {
						a['belegdatum'] = ""
					}
					if (!("belegdatum" in b)) {
						b['belegdatum'] = ""
					}
					let x = a['belegdatum'].toLowerCase();
					let y = b['belegdatum'].toLowerCase();
				    if(x === "" || x === null) return 1;
					if(y === "" || y === null) return -1;
					if(x === y) return 0;
					if (sortSetting.sortDirection == "asc") {
						return x < y ? -1 : 1;
					} else {
						return x > y ? -1 : 1;
					}
				});
			} else if (sort == "eingangsdatum") {
				documents.sort(function(a, b){
					if (!("stored_date" in a)) {
						a['stored_date'] = ""
					}
					if (!("stored_date" in b)) {
						b['stored_date'] = ""
					}
					let x = a['stored_date'].toLowerCase();
					let y = b['stored_date'].toLowerCase();
				    if(x === "" || x === null) return 1;
					if(y === "" || y === null) return -1;
					if(x === y) return 0;
					if (sortSetting.sortDirection == "asc") {
						return x < y ? -1 : 1;
					} else {
						return x > y ? -1 : 1;
					}
				});
			} else if (sort == "belegtyp") {
				documents.sort(function(a, b){
					if (!("belegtyp" in a)) {
						a['belegtyp'] = ""
					}
					if (!("belegtyp" in b)) {
						b['belegtyp'] = ""
					}
					let x = a['belegtyp'].toLowerCase();
					let y = b['belegtyp'].toLowerCase();
				    if(x === "" || x === null) return 1;
					if(y === "" || y === null) return -1;
					if(x === y) return 0;
					if (sortSetting.sortDirection == "asc") {
						return x < y ? -1 : 1;
					} else {
						return x > y ? -1 : 1;
					}
				});
			} else if (sort == "belegstatus") {
				documents.sort(function(a, b){
					if (!("statuslist" in a)) {
						a['statuslist'] = ""
					}
					if (!("statuslist" in b)) {
						b['statuslist'] = ""
					}
					let x = a['statuslist']
					let y = b['statuslist']
				    if(x === "" || x === null) return 1;
					if(y === "" || y === null) return -1;
					if(x === y) return 0;
					if (sortSetting.sortDirection == "asc") {
						return x < y ? -1 : 1;
					} else {
						return x > y ? -1 : 1;
					}
				});
			} else {
				return
			}

		},

		queryBuilder(query) {
			if (this.belegnummer != "") {
				query = query + " AND belegnummer:" + this.belegnummer
			}
			if (this.eingangsdatum != "" && this.eingangsdatum[0] != null && this.eingangsdatum[1] != null) {
				var startdate = moment(this.eingangsdatum[0]).subtract(2, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
				var enddate = moment(this.eingangsdatum[1]).add(24, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
				query = query + " AND stored_date:" + '["' + startdate + '" TO "' + enddate + '"]'
			}
			if (this.belegdatum != "" && this.belegdatum[0] != null && this.belegdatum[1] != null) {
				var startdate = moment(this.belegdatum[0]).subtract(2, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
				var enddate = moment(this.belegdatum[1]).add(24, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
				query = query + " AND belegdatum:" + '["' + startdate + '" TO "' + enddate + '"]'
			}
			if (this.rechnungssteller != "") {
				query = query + " AND kreditorname:" + this.rechnungssteller
			}
			if (this.datenherkunft != "") {
				query = query + " AND datenherkunft:" + this.datenherkunft
			}
			if (this.dokumententyp != "") {

				var docTypen = this.dokumententyp.slice();
				if (docTypen.includes('Validierungsbericht XML')) {
					var index = (docTypen.findIndex(function(item){
	    				return item.indexOf("Validierungsbericht XML") !== -1;
					}));
					if (index == 0) {
						docTypen[index] = "%01Validierungsbericht AND content-type:application/xml)"
					} else {
						docTypen[index] = "%02Validierungsbericht AND content-type:application/xml)"
					}
				}
				if (docTypen.includes('Validierungsbericht PDF')) {
					var index = (docTypen.findIndex(function(item){
	    				return item.indexOf("Validierungsbericht PDF") !== -1;
					}));
					if (index == 0) {
						docTypen[index] = "%01Validierungsbericht AND content-type:application/pdf)"
					} else {
						docTypen[index] = "%02Validierungsbericht AND content-type:application/pdf)"
					}
				}
				if (docTypen.includes('XML-Rechnung')) {
					var index = (docTypen.findIndex(function(item){
	    				return item.indexOf("XML-Rechnung") !== -1;
					}));
					docTypen[index] = "Rechnungsanhang"
				}

				console.log(this.dokumententyp)

				var typen = docTypen.toString()
				var result_temp = typen.replace(/,/g, " OR belegtyp:")
				var result = result_temp.replace(/belegtyp:%02/g, "(belegtyp:")
				var query_temp = query + " AND (belegtyp:" + result + ")"
				var query = query_temp.replace(/\(belegtyp:%01/g, "((belegtyp:")
			} else {
				query = query + " AND belegtyp:*"
			}
			return query
		},

		/*searchDocuments(searchQuery = "") {
			this.$store.commit('setLoadingWorkingScreen')
			this.$store.commit('emptyDocuments')
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url
	        }
			this.$store.dispatch('retrieveTicket', data)
		        .then(resp => {
		        	var ticket = resp.data.ticket
		        	if (searchQuery != "") {
		        		var query = searchQuery
		        	} else {
		        		var query = ""
		        		query = this.queryBuilder(query)
		        	}
					var data = {
						'nonce': this.wpData.nonce,
						'restURL': this.wpData.rest_url,
						'ticket': ticket,
						'mandant': this.$store.getters.getMandant,
						'query': query
					}
					this.$store.dispatch('getDocuments', data)
					    .then(resp => {

					    	if (resp.data.description == "invalid ticket") {
					    		var data = {
						            'nonce': this.wpData.nonce,
						            'restURL': this.wpData.rest_url
						        }
								this.$store.dispatch('checkAndCreatePortinvoiceTicket', data)
									.then(resp => {
										console.log("neues Ticket erzeugt und in Datenbank gespeichert")
										if (resp.data.code == 200) {
											var ticket = resp.data.ticket
											var data = {
												'nonce': this.wpData.nonce,
												'restURL': this.wpData.rest_url,
												'ticket': ticket,
												'mandant': this.$store.getters.getMandant,
												'query': query
											}
											this.$store.dispatch('getDocuments', data)
											    .then(resp => {
											    	this.submitSearch = true
											    	this.$store.commit('setDocuments', resp.data.data)
											    	this.$store.commit('setTrefferAnzahl', resp.data.data.length)
											    	this.$store.commit('setSearchQuery', query)
											        var searchParameter = {
											        	'belegnummer': this.belegnummer,
											        	'datenherkunft': this.datenherkunft,
											        	'dokumententyp': this.dokumententyp,
											        	'belegdatum': this.belegdatum,
											        	'rechnungssteller': this.rechnungssteller,
											        	'eingangsdatum': this.eingangsdatum
											        }
											    	this.$store.commit('setSearchParameter', searchParameter)
											    	this.$store.commit('setStopLoadingWorkingScreen')
											    })
											    .catch(err => {
											    	this.$store.commit('setStopLoadingWorkingScreen')
													console.log("Ticket immer noch fehlerhaft -> keine Dokumente geladen")
											    })
										}
									})
									.catch(err => {
										console.log("neues Ticket konnte nicht erzeugt werden #2")
										this.$store.commit('setStopLoadingWorkingScreen')
									})

					    	} else {
						    	this.submitSearch = true
						    	this.$store.commit('setDocuments', resp.data.data)
						    	this.$store.commit('setTrefferAnzahl', resp.data.data.length)
						    	this.$store.commit('setSearchQuery', query)
						        var searchParameter = {
						        	'belegnummer': this.belegnummer,
						        	'datenherkunft': this.datenherkunft,
						        	'dokumententyp': this.dokumententyp,
						        	'belegdatum': this.belegdatum,
						        	'rechnungssteller': this.rechnungssteller,
						        	'eingangsdatum': this.eingangsdatum
						        }
						    	this.$store.commit('setSearchParameter', searchParameter)
						    	this.$store.commit('setStopLoadingWorkingScreen')
					    	}
					    })
						.catch(err => {
							console.log("Dokumente konnten nicht geladen werden.")
							this.$store.commit('setStopLoadingWorkingScreen')
						})
		        })
				.catch(err => {
				    this.$store.commit('setStopLoadingWorkingScreen')
				    console.log(err)
				})
		},*/

		searchDocuments(searchQuery = "") {
			this.$store.commit('setLoadingWorkingScreen')
			this.$store.commit('emptyDocuments')

		    if (searchQuery != "") {
		        var query = searchQuery
		    } else {
		        var query = ""
		        query = this.queryBuilder(query)
		    }
			var data = {
				'nonce': this.wpData.nonce,
				'restURL': this.wpData.rest_url,
				'mandant': this.$store.getters.getMandant,
				'query': query
			}
			this.$store.dispatch('getDocuments', data)
				.then(resp => {

						    	this.submitSearch = true
						    	this.$store.commit('setDocuments', resp.data.data.result)
						    	this.$store.commit('setTrefferAnzahl', resp.data.data.result.length)
						    	this.$store.commit('setSearchQuery', query)
						        var searchParameter = {
						        	'belegnummer': this.belegnummer,
						        	'datenherkunft': this.datenherkunft,
						        	'dokumententyp': this.dokumententyp,
						        	'belegdatum': this.belegdatum,
						        	'rechnungssteller': this.rechnungssteller,
						        	'eingangsdatum': this.eingangsdatum
						        }
						    	this.$store.commit('setSearchParameter', searchParameter)
						    	this.$store.commit('setStopLoadingWorkingScreen')
				})
				.catch(err => {
					console.log("Dokumente konnten nicht geladen werden.")
					this.$store.commit('setStopLoadingWorkingScreen')
				})
		},

		resetFilterValues() {
			this.belegnummer = ""
	        this.validierungsstatus = ""
	        this.openFilter = false
			this.filterButtonLabel = "Filter öffnen"
		},

		toggleFilterBlock() {
			if (this.openFilter) {
				this.openFilter = false
				this.filterButtonLabel = "Filter öffnen"
			} else {
				this.openFilter = true
				this.filterButtonLabel = "Filter schließen"
			}
		}

	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.documentslist {
	width: 100%;
	margin-bottom: 30px;
	border-bottom: 15px solid #5f5e5e;
	margin-top: 30px;
}
.documentslist tr th, .documentslist tr td {
	text-align: left;
	font-size:15px;
}

table.documentslist tr.head {
	border-bottom: 1px solid #5f5e5e;
}

table.documentslist tr {
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
}

table.documentslist tr.head th {
	font-weight: bold;
	color: #fff;
padding: 15px 20px;
}

table.documentslist tr td {
padding: 20px;
}

table.documentslist tr:nth-child(even) {
	background-color: #f4f4f4;
}

table.documentslist tr:hover {
  background-color: #ccc;
  cursor: pointer;
}

table.documentslist tr:active {
	background-color: #a8332e;
	color: #fff;
}

table.documentslist tr.head, table.documentslist tr.head:hover {
  background-color: #5f5e5e;
  cursor: default;
}

ul.documentslist li {
   border-bottom:1px solid #ccc;
   padding-bottom:20px;
   padding-top:20px;
   padding-left: 20px;
	cursor:pointer;
}

ul.documentslist li:nth-child(1) {
	border-top:1px solid #ccc;
}

ul.documentslist li:nth-child(odd) {
   background-color: #f4f4f4;
}

</style>



// WEBPACK FOOTER //
// src/components/SucheOverview.vue